<div class="container-fluid">
    <div class="row pl--1rem8  d-flex align-items-center">
      <div class="col-md-10 page-heading">
        <h4>Manage Visas</h4>
        <p>Manage existing visa or create a new visa</p>
      </div>
      <div class="col-md-2 add-task-btn createNewPlaceholderDiv">
        <button type="button" (click)="buildNewVisa()"
            class="im-btn add-task-list-btn button_whitebg im-btn-with-icon im-btn-outline-primary">
            <i class="fa fa-plus im-drop-icon"></i>&nbsp; Build New Visa
        </button>
      </div>
      <app-help-video-overlay #helpVideoComponent></app-help-video-overlay>
    </div>


    <mat-divider></mat-divider>

    <mat-divider class="pb-15"></mat-divider>

    <div class="row tab-container">
      <div class="col-2  tab-label tab-height" (click)="toggleMode('CREATED')"
        [ngClass]="{'activeTimeLine': toggleStatus === 'CREATED' }">
        <div class="lbl-text">Created Visas</div>
      </div> <!--(click)="toggleMode('STANDARD')"-->
      <div class="col-2  tab-label tab-height disabled"
        [ngClass]="{'activeTimeLine': toggleStatus === 'STANDARD'}">
        <div class="lbl-text">Standard Visas</div>
      </div>
      <div class="col"></div>
      <div class="filter col-1 mt-2">
        <p-overlayPanel #visasfilterPanel  [dismissable]="false">
          <ng-template pTemplate>
            <div class="row col-md-12 pl-0 pr-0 pb-2">
              <div class="col-md-6 p-0 pb-2 pr-1">
                <label class="label-cls">Country</label>
                <p-dropdown class="w-100" optionValue="countryCode" [options]="listCountry"
                  [(ngModel)]="filter.countryCode" placeholder="Country" optionLabel="countryName">
                </p-dropdown>
              </div>
              <div class="col-md-6 p-0 pb-2">
                <label class="label-cls">Form Type</label>
                <p-dropdown class="w-100" optionValue="code" [options]="formTypeArr"
                  [(ngModel)]="filter.formType" placeholder="Form Type" optionLabel="name" (onChange)="handleChange()">
                </p-dropdown>
              </div>
            </div>
            <div class="row col-md-12 pt-2 pb-2 pl-0 pr-0" *ngIf="filter.formType != 'I589FORM'">
              <div class="col-md-6 p-0 pb-2 pr-1">
                <label class="label-cls">Visa Type</label>
                <p-dropdown class="w-100" optionValue="code" [options]="visaTypeArr"
                  [(ngModel)]="filter.visaType" placeholder="Visa Type" optionLabel="name" (onChange)="handleVisaTypeChange()">
                </p-dropdown>
              </div>
              <div class="col-md-6 p-0">
                <label class="label-cls">Petition Type</label>
                <p-dropdown class="w-100" optionValue="code" [options]="petitionTypeArr"
                  [(ngModel)]="filter.petitionType" placeholder="Petition Type" optionLabel="name">
                </p-dropdown>
              </div>
            </div>
            <div class="row col-md-12 pt-2 pb-2 pl-0 pr-0" *ngIf="filter.formType === 'I589FORM'">
              <div class="col-md-6 p-0 pb-2 pr-1">
                <label class="label-cls">Immigiration Catagory</label>
                <p-dropdown class="w-100" optionValue="code" [options]="visaTypeArr"
                  [(ngModel)]="filter.immCategoryCode" placeholder="Immigiration Catagory" optionLabel="name" (onChange)="handleVisaTypeChange()">
                </p-dropdown>
              </div>
              <div class="col-md-6 p-0">
                <label class="label-cls">Immigiration Classification</label>
                <p-dropdown class="w-100" optionValue="code" [options]="petitionTypeArr"
                  [(ngModel)]="filter.immClassificationCode" placeholder="Immigiration Classification" optionLabel="name">
                </p-dropdown>
              </div>
            </div>


            <mat-divider></mat-divider>
            <div class="row col-md-12 pt-3">
              <div class="col-md-4"></div>
              <div class="col-md-4">
                <button pButton type="button" label="Cancel" title="Cancel" (click)="filterCancel();visasfilterPanel.hide();"
                  class="p-button-outlined pull-right"></button>
              </div>
              <div class="col-md-4 p-0">
                <button pButton type="button" label="Apply" title="Apply" class="p-button-primary p-button apply-btn"
                  (click)="handleFilterChange();visasfilterPanel.hide()"></button>
              </div>
            </div>
          </ng-template>
        </p-overlayPanel>

        <button type="text" class="taskFilter-btn" pButton label="Filter" (click)="visasfilterPanel.toggle($event)"
          icon="pi pi-filter" iconPos="right"> </button>
      </div>
      <div class="mb-3 search-btn col-2">
        <div class="input-group search-text">
          <input class="form-control im-pt-3 pr-5" #searchVisa (search)="resetSearch()" type="search"
            placeholder="Search Visa">
          <span class="input-group-append">
            <button class="btn rounded-pill ml-n4r" title="search" type="button">
              <i class="fa fa-search border-0" alt=""></i>
            </button>
          </span>
        </div>
      </div>
    </div>
    <div class="row">
        <router-outlet></router-outlet>
    </div>

  </div>
